import * as React from 'react'
import { connect } from 'react-redux'
import { ContextRoute } from '../app/context'
import { ServiceType } from '../domain/Service'
import { ApplicationState } from '../redux/ApplicationState'
import { NavigationEntry, ServiceTypeNavigation } from '../service-type-navigation'

interface StateProps {
    currentRoute: ContextRoute
}

type Props = StateProps & {
    activeType: string
}

class SnapshotNavigation extends React.Component<Props> {
    public render = () => {
        const navigationEntries = this.buildNavigationEntries()

        return (
            <ServiceTypeNavigation
                navigationEntries={navigationEntries}
                currentRoute={this.props.currentRoute}
                showAddMarkerButton={true}
            />
        )
    }

    private buildNavigationEntries(): NavigationEntry[] {
        const route = 'XhprofProfilerBundle.Snapshot.show'

        return [
            { label: 'PHP Performance', type: ServiceType.php, route },
            { label: 'External HTTP Calls', type: ServiceType.external, route },
        ]
    }
}

export default connect<StateProps>((globalState: ApplicationState, props) => {
    return {
        ...props,
        currentRoute: globalState.tidewaysContext.route,
    }
})(SnapshotNavigation)
